import { useState, useCallback } from 'react'

const usePage = (defaultPage = '') => {
  const [page, setPage] = useState(defaultPage)

  const setCurrentPage = useCallback(currentPage => {
    setPage(currentPage)
  }, [])

  return {
    page,
    setCurrentPage,
  }
}

export default usePage
